import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PosHttpService } from '../../../services/pos.http.service';
import { utilitySetup } from './utility-setup.component';

@Injectable({
  providedIn: 'root'
})
export class UtilitySetupService {
  requestMap: any;
  constructor(
    private posHttpSvcs: PosHttpService,
  ) { }

  getUtilitySetup(): Observable<any> {
    return this.posHttpSvcs.authGet(`v1/ui/utilitySetup`, 'utilitySetup');
  }

  updateUtilitySetup(objectHash: utilitySetup): Observable<any> {
    this.requestMap = this.posHttpSvcs.appendHeaders({}, "AlertDashboard")
    return this.posHttpSvcs.authPut('v1/ui/utilitySetup', "AlertDashboard", objectHash);
  }

  reload(): Observable<any>{
    return this.posHttpSvcs.authGet(`v1/ui/reloadSchema`, 'reloadSchema');
  }

}